var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createAction, createAsyncThunk } from '@reduxjs/toolkit';
import { loginApi, } from 'apis/login';
import { isResponseWithData } from 'utils/apis/axios';
import { createAsyncThunkAction } from 'utils/redux/createAsyncThunkAction';
import { createShowModalAction } from './utils/createShowModalAction';
const prefix = 'app';
export const appActions = {
    logIn: createAction(`${prefix}/logIn`),
    logOut: createAsyncThunk(`${prefix}/logOut`, (arg, { dispatch, rejectWithValue }) => __awaiter(void 0, void 0, void 0, function* () {
        const response = yield dispatch(loginApi.endpoints.deleteAppLogin.initiate({
            refreshToken: arg.refreshToken,
        }));
        return isResponseWithData(response)
            ? response.data
            : rejectWithValue(response.error);
    })),
    setError: createAction(`${prefix}/error`),
    setStatus: createAction(`${prefix}/status`),
    showModal: createShowModalAction(`${prefix}/showModal`),
    hideModal: createAction(`${prefix}/hideModal`),
    getFeatureFlags: createAsyncThunkAction(`${prefix}/getFeatureFlags`),
    getPresence: createAsyncThunkAction(`${prefix}/getPresence`),
    conversationTransferRequest: createAsyncThunkAction(`${prefix}/conversationTransferRequest`),
    conversationTransferClear: createAction(`${prefix}/conversationTransferClear`),
    setOrganization: createAction(`${prefix}/setOrganization`),
    setOrganizations: createAction(`${prefix}/setOrganizations`),
};
